import { TeamLanding } from '@frx/frx-program-defaults';

export const TeamPage = () => {
  return <TeamLanding />;
};
